import styled from "styled-components";

export const StyledError = styled.div`
  ${({ theme }) => theme.fonts.mulishRegular};
  font-size: 11px;
  line-height: 1;
  letter-spacing: -0.025em;
  color: ${({ theme }) => theme.colors.error};
  margin-top: 8px;
  ${({ customStyle }) => customStyle && customStyle};
`;